import React, { useState } from 'react';
import { Card, Button, Table, Badge, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { PHANBIENDOCLAP_API, BaseGatewayImage } from '@app/utils/apiUrl';
import { Get, DeleteSingle } from '@app/utils/httpProvider';
import { toast } from 'react-toastify';
import PhanBienDocLapEdit from './PhanBienDocLapEdit';
import PhanBienDocLapAdd from './PhanBienDocLapAdd';
import { ConfirmModal } from '@app/modules/modal/ConfirmModal';
import { useMutation, useQueryClient } from 'react-query';

const DuyetPhanBienDocLap = ({ hoSoId }) => {
    const [viewMode, setViewMode] = useState('list');
    const [dataEdit, setDataEdit] = useState(null);
    
    // Delete state
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    
    const queryClient = useQueryClient();

    const { isLoading, data: queryData, refetch } = useQuery(
        ['duyetPhanBienDocLapData', hoSoId],
        () => Get(PHANBIENDOCLAP_API.GET_PAGING, null, { HoSoNghienCuuSinhId: hoSoId, PageIndex: 1, PageSize: 100 }),
        { 
            enabled: !!hoSoId,
            keepPreviousData: true
        }
    );

    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else if (queryData.data?.$values) {
            dataList = queryData.data.$values;
        }
    }

    const deleteFunc = useMutation((id) => DeleteSingle(PHANBIENDOCLAP_API.DELETE_ITEM, id, null));

    const deleteAction = (id) => {
        setIdWantDelete(id);
        setConfirmDelMessage('Bản ghi phản biện độc lập này');
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Xóa thành công');
                    queryClient.invalidateQueries(['duyetPhanBienDocLapData', hoSoId]);
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra khi xóa');
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Có lỗi xảy ra');
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const renderTooltip = (props, text) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );

    return (
        <>
        <Card className="h-100">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold text-primary m-0">Phản biện độc lập</h5>
                    <Button variant="success" size="sm" onClick={() => setViewMode('add')}>
                        <i className="fas fa-plus mr-1"></i> HLĐT Thêm mới
                    </Button>
                </div>
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th className="text-center" width="50">STT</th>
                                    <th className="text-center">Biên bản giải trình</th>
                                    <th className="text-center">File đính kèm</th>
                                    <th className="text-center" width="120">Thao tác</th>
                                </tr>
                            </thead>
                        <tbody>
                            {dataList.length > 0 ? (
                                dataList.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className="text-center">{index + 1}</td>
                                        <td className="text-center">
                                            {item.isBanGiaiTrinh ? <Badge variant="success">Có</Badge> : <Badge variant="danger">Không</Badge>}
                                        </td>
                                        <td className="text-center">
                                            {item.fileDinhKem ? (
                                                (() => {
                                                    const path = item.fileDinhKem;
                                                    const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
                                                    const safePath = path.startsWith('/') ? path : `/${path}`;
                                                    const fileUrl = path.startsWith('http') ? path : `${baseUrl}${safePath}`;
                                                    let name = path.split('/').pop() || 'File';
                                                    name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                                    return (
                                                        <a href={fileUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm text-left mb-1 mr-1" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                                            <i className="fas fa-paperclip mr-1"></i> {name}
                                                        </a>
                                                    );
                                                })()
                                            ) : (
                                                <span className="text-muted">Không có</span>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            {(() => {
                                                return (
                                                    <div className="d-flex justify-content-center text-nowrap">
                                                        <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Sửa dành cho HLĐT')}>
                                                            <Button variant="info" size="sm" onClick={() => { setDataEdit(item); setViewMode('edit'); }} className="mr-1">
                                                                <i className="fas fa-edit"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Xóa')}>
                                                            <Button variant="danger" size="sm" onClick={() => deleteAction(item.id)}>
                                                                <i className="fas fa-trash"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </div>
                                                );
                                            })()}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center text-muted">
                                        Chưa có dữ liệu Phản biện độc lập
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    </div>
                )}
            </Card.Body>
        </Card>

        <ConfirmModal
            isOpen={openConfirmDeleteModal}
            confirmType="delete"
            goBackAfterDelete={false}
            handleAccept={acceptDelete}
            handleCancel={cancelDelete}
            content={confirmDelMessage}
        />
        
        {viewMode === 'edit' && dataEdit && (
            <PhanBienDocLapEdit hoSoId={hoSoId} dataEdit={dataEdit} setViewMode={setViewMode} refreshList={refetch} />
        )}
        {viewMode === 'add' && (
            <PhanBienDocLapAdd hoSoId={hoSoId} setViewMode={setViewMode} refreshList={refetch} />
        )}
        </>
    );
};

export default DuyetPhanBienDocLap;
